module.exports = __webpack_public_path__ + "img/support_on.60ff4b5a.png";